import { setPush } from '@packages/header/src/pushRouter';

export const pushTool = { setPush };
export { Header, CmsComs } from '@packages/header/src/componentsBundle';
